import React from "react";
// import "./TermsAndConditions.css";

const DisclaimerPolicy = () => {
    return (
        <div className="tc-container">
            <h1 className="tc-title">Disclaimer</h1>

            <section className="tc-section">
                <h2>1. General Usage</h2>
                <p>
                    All products and services provided by Way4Track are intended strictly for lawful and responsible use.
                    Customers are required to ensure that usage complies with all applicable laws, regulations,
                    and accepted standards of conduct within India.
                </p>
                <p>
                    Any misuse, illegal activity, or violation of applicable laws resulting from the use of the product
                    shall be solely the responsibility of the customer.
                </p>
            </section>

            <section className="tc-section">
                <h2>2. Nature of Products</h2>
                <p>
                    Way4Track provides hardware devices, including GPS tracking systems, along with related services.
                </p>
                <p>Once the product is delivered:</p>
                <ul>
                    <li>The Company does not control how the product is used</li>
                    <li>The Company does not monitor user activity</li>
                    <li>The Company does not interfere with customer operations</li>
                </ul>
                <p>
                    All usage decisions remain entirely under the control of the customer.
                </p>
            </section>

            <section className="tc-section">
                <h2>3. GPS & Tracking Usage Compliance</h2>
                <p>
                    Certain products may involve tracking or monitoring capabilities.
                    Customers must ensure responsible and lawful usage at all times.
                </p>
                <ul>
                    <li>Devices must not be used for unauthorized tracking</li>
                    <li>Required consent must be obtained before tracking individuals or assets</li>
                    <li>Usage must comply with Indian privacy and data protection laws</li>
                </ul>
                <p>
                    Any violation may lead to civil or criminal liability, for which Way4Track holds no responsibility.
                </p>
            </section>

            <section className="tc-section">
                <h2>4. No Liability for Misuse</h2>
                <p>
                    Way4Track shall not be liable for any consequences arising from misuse of its products after delivery.
                </p>
                <ul>
                    <li>Unauthorized surveillance or tracking</li>
                    <li>Violation of privacy or data protection laws</li>
                    <li>Use of the device for illegal activities</li>
                    <li>Any legal disputes arising from product usage</li>
                </ul>
                <p>
                    The Company acts solely as a technology provider and has no control over end usage.
                </p>
            </section>

            <section className="tc-section">
                <h2>5. Installation Responsibility</h2>
                <p>
                    Proper installation is critical for optimal product performance.
                </p>
                <ul>
                    <li>Improper installation may lead to malfunction</li>
                    <li>Installation by unauthorized personnel is discouraged</li>
                    <li>Customers must follow official installation guidelines</li>
                </ul>
                <p>
                    Way4Track is not responsible for issues caused by incorrect installation.
                </p>
            </section>

            <section className="tc-section">
                <h2>6. Technical Limitations</h2>
                <p>
                    Product performance may depend on external conditions beyond the Company’s control.
                </p>
                <ul>
                    <li>Network availability and signal strength</li>
                    <li>Environmental and geographical conditions</li>
                    <li>Device compatibility and third-party dependencies</li>
                </ul>
                <p>
                    Way4Track does not guarantee uninterrupted or error-free operation under all conditions.
                </p>
            </section>

            <section className="tc-section">
                <h2>7. Limitation of Liability</h2>
                <p>
                    To the maximum extent permitted under applicable law, Way4Track shall not be liable for:
                </p>
                <ul>
                    <li>Indirect or consequential damages</li>
                    <li>Loss of business, revenue, or profits</li>
                    <li>Data loss or service interruptions</li>
                    <li>Issues arising from misuse or improper handling</li>
                </ul>
            </section>

            <section className="tc-section">
                <h2>8. Customer Acknowledgment</h2>
                <p>
                    By purchasing and using Way4Track products, the customer acknowledges and agrees that:
                </p>
                <ul>
                    <li>They understand the product’s intended use</li>
                    <li>They will use the product lawfully</li>
                    <li>They accept full responsibility for its usage</li>
                </ul>
            </section>

        </div>
    );
};

export default DisclaimerPolicy;